import styled, { keyframes } from 'styled-components'

const mirrorShimmer = keyframes`
  0% {
    background-position: -150% 0;
  }
  100% {
    background-position: 250% 0;
  }
`

export const StyledSkeleton = {
  Host: styled.div<{
    $isLoading: boolean
    $height: number
    $radius: number
  }>`
    display: contents;

    ${({ $isLoading, $height, $radius }) =>
      $isLoading &&
      `
        display: block;
        position: relative;
        width: 100%;
        height: ${$height}px;
        overflow: hidden;
        border-radius: ${$radius}px;
        pointer-events: none;
      `}
  `,
  Overlay: styled.div<{
    $background: string
    $radius: number
    $height: number
    $width?: number
  }>`
    position: absolute;
    top: 0;
    height: ${({ $height }) => $height}px;
    ${({ $width }) =>
      $width
        ? `width: ${$width}px; left: 50%; transform: translateX(-50%);`
        : 'left: 0; right: 0;'}
    z-index: 3;

    border-radius: ${({ $radius }) => $radius}px;
    background: ${({ $background }) => $background};

    &::after {
      content: '';
      position: absolute;
      inset: 0;

      border-radius: inherit;
      background: linear-gradient(
        100deg,
        transparent 30%,
        rgba(255, 255, 255, 0.45) 50%,
        transparent 70%
      );
      background-size: 200% 100%;
      background-repeat: no-repeat;
      animation: ${mirrorShimmer} 1.6s ease-in-out infinite;
    }
  `,
}
